import knowledgeFlow from "@static/sponsorLogos/knowledgeflow.png";
import flock from "@static/sponsorLogos/flock.png";
import googleLeads from "@static/sponsorLogos/googleads.png";

export default [
  {
    img: {
      src: knowledgeFlow,
      alt: "Knowledgeflow Logo",
    },
    name: "Knowledgeflow Foundation",
    link: "https://knowledgeflow.org/",
  },
  {
    img: {
      src: flock,
      alt: "Flock Logo",
    },
    name: "Flock",
    link: "https://www.flock.com/",
  },
  {
    img: {
      src: googleLeads,
      alt: "Google Ads Logo",
    },
    name: "Google Ads",
    link: "https://www.google.ca/grants/",
  },
];

export const quizQuestions = [
  {
    question: "Google is the oldest search engine ever.",
    answer: false,
    explanation:
      "The first web search engine was Archie, created in 1990 by Alan Emtage, a student at McGill University in Montreal. Google was created in 1998 by Larry Page and Sergey Brin while they were attending Stanford University in Stanford, California.",
  },
  {
    question: "Between 10,000 and 20,000 companies across the world use Flock.",
    answer: false,
    explanation:
      "In 2023, more of 30 000 companies use Flock, across the world.",
  },
  {
    question: "Managed Privacy Canada tries to help non-profit organizations.",
    answer: true,
    explanation:
      "Managed Privacy Canada tries to help non-profit organizations by giving a discount that can be renewed every year in re-submitting documentation proving that the organization still has NPO status.",
  },
  {
    question:
      "One of every 10 Google searches is a question that has never been Googled before.",
    answer: false,
    explanation:
      "Actually, it is one of every 6 Google searches! What you're Googling could be the first time it's been searched on the site!",
  },
  {
    question: "Flock was founded by an American entrepreneur in 2014.",
    answer: false,
    explanation:
      "Flock was founded in 2014 by Bhavin Turakhia, an Indian serial entrepreneur who was born in Mumbai, India. He currently lives in London but Flock headquarters are still located in Mumbai.",
  },
  {
    question:
      "Managed Privacy Canada is the premier privacy management company in Canada.",
    answer: true,
    explanation:
      "Service continuity and dependable, on-demand expertise make MPC the first and the only organization of its kind in Canada, so far.",
  },
  {
    question: "You can thank Jennifer Lopez for Google Images.",
    answer: true,
    explanation:
      "In February 2000, U.S. singer and actor Jennifer Lopez wore a revealing jungle print dress by the designer Versace to the Grammy Awards. According to Google, it became the most popular search ever, in just one night. At the time, Google was just text-based. The demand for a picture of Lopez's dress inspired Google to make its own section for images.",
  },
  {
    question:
      "Flock won the award of the Best Business Communication App of the Year, in 2016.",
    answer: true,
    explanation:
      "Flock won the award of the Best Business Communication App of the Year by Global Mobile App Summit & Awards, in July 2016. It also won the Best Mobile Enterprise Product/Service Award by India Digital Awards, in 2017.",
  },
  {
    question: "Managed Privacy Canada has a Youtube channel.",
    answer: true,
    // TODO: Link here.
    explanation:
      "MPC Youtube channel provides tutorials, webinars and presentations. Check the 23 videos by following this link: https://www.youtube.com/@managedprivacycanada6437/videos",
  },
  {
    question: "The original Google hard drive was stored in a Lego.",
    answer: true,
    explanation:
      "In a story reported by Stanford University, Lego blocks were originally used to hold the Google hard drive. The creators said it was because it had better ventilation than just storing a drive in a box.",
  },
];
